import React, { FormEvent } from 'react'
import autosize from 'autosize'
import classNames from 'classnames'

import FieldWrapper from '../FieldWrapper'
import RequiredField from '../../RequiredField'

import style from './style.scss'

export type TextAreaType = {
  className?: string
  defaultValue?: string
  errorText?: string
  inputId: string
  isLabelHidden?: boolean
  isReadOnly?: boolean
  isRequired?: boolean
  label: string
  maxLength?: number
  minLength?: number
  placeholder?: string
  rows?: number
  value?: string
}

type Props = TextAreaType & {
  updateField?: (arg0: string) => void
}

class TextArea extends React.PureComponent<Props> {
  textarea: { current: null | HTMLTextAreaElement }

  static defaultProps = {
    className: '',
    defaultValue: undefined,
    errorText: '',
    isLabelHidden: false,
    isReadOnly: false,
    isRequired: false,
    maxLength: undefined,
    minLength: undefined,
    placeholder: undefined,
    rows: 1,
    value: undefined,
  }

  constructor(props: Props) {
    super(props)

    this.textarea = React.createRef()
  }

  componentDidMount() {
    if (this.textarea.current) {
      autosize(this.textarea.current)
    }
  }

  handleChange = (evt: {
    target: { setCustomValidity: (arg0: string) => void; value: string }
  }) => {
    const { updateField, errorText } = this.props

    // avoids potential runtime error
    if (!updateField) {
      return null
    }

    errorText && evt.target.setCustomValidity('')
    return updateField(evt.target.value)
  }

  handleInvalid = (evt: FormEvent<HTMLTextAreaElement>) => {
    const { errorText } = this.props

    // avoids potential runtime error
    if (!errorText) {
      return null
    }

    evt.currentTarget.setCustomValidity(errorText)
  }

  render() {
    const {
      className,
      defaultValue,
      errorText,
      isLabelHidden,
      inputId,
      isReadOnly,
      isRequired,
      label,
      maxLength,
      minLength,
      placeholder,
      rows,
      updateField,
      value,
    } = this.props

    return (
      <FieldWrapper className={className}>
        <label
          className={classNames({ [style.hideLabel]: isLabelHidden })}
          htmlFor={inputId}
        >
          {label}
          {isRequired && <RequiredField />}
        </label>
        <textarea
          ref={this.textarea}
          className={style.input}
          defaultValue={defaultValue}
          id={inputId}
          maxLength={maxLength}
          minLength={minLength}
          placeholder={placeholder}
          readOnly={isReadOnly}
          required={isRequired}
          rows={rows}
          style={{ resize: 'none' }}
          value={isReadOnly ? undefined : value}
          onChange={updateField ? this.handleChange : undefined}
          onInvalid={errorText ? this.handleInvalid : undefined}
        />
      </FieldWrapper>
    )
  }
}

export default TextArea
